import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EmployeeListService } from "../../../../common/services/employee-listing.service";
import { RequestParams } from "../../../../common/rest-api/models/request-params";
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
@Component({
  selector: "app-cost-center-employee-view-page",
  templateUrl: "cost-center-employee-view.page.html",
  styleUrls: ["./cost-center-employee-view.page.scss"],
})
export class CostCenterEmployeeViewPage implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private employeeListService: EmployeeListService,
    public authService: GtrakAuthService,
  ) {}

  costCenterCode: string;
  loaded:boolean=false;
  totalPages: number = 0;
  totalElements: number = 0;

  requestParams: any;

  currPage: number;
  pageSize: number;
  public rows: any;
  submitting: boolean;
  currentRoute: string;

  async ngOnInit() {
    this.loaded=false;
    this.currentRoute = this.router.url;
    this.requestParams = new RequestParams();
    this.costCenterCode = this.route.snapshot.paramMap.get("costCenterCode");
    this.requestParams.filters.CostCenter = this.costCenterCode;
    this.rows = [];
    this.currPage = 1;
    this.pageSize = 500;

    // For the listing view, we want to exclude any inactive employees.
    this.requestParams.filters.ExcludeInactive = true;
    await this.getEmployees();
    this.loaded=true;
  }

  async getEmployees() {
    this.loaded=false;
    this.submitting = true;
    this.requestParams.setPaging(this.currPage, this.pageSize);
    var employees = await this.employeeListService.query(this.requestParams);
    this.totalElements = employees.totalRecords;
    this.totalPages = employees.totalPages;
    this.rows = employees.results;
    this.submitting = false;
    this.loaded=true;
  }

  setPage(page): void {
    this.currPage = page + 1;
    this.getEmployees();
  }
}
